<template>

  <div id="contacto">

<!--     <v-container>
      <div class="lines-contact global-page linear-gradient">
          <div v-for="index in 5"
          :key="index"
          class="infoPage"></div>
      </div>
      <div id="background-home"></div>
    </v-container> -->

    <v-container class="first-content-contact second-content">
      <v-row no-gutters class=" ma-5">
        <v-col lg="6" sm="12" md="6" cols="12" class="">
          <h1 class="mt-5"> {{ $t('contacte[0].formularititol')}}</h1> 
          <tense-form-address  />
      <!--      <img src="../../src/assets/images/informacio.jpg"
              data-aos="fade-in"
              data-aos-duration="2000"
              data-aos-delay="100"
              class="foto-contacte"
              alt="informació Packetgrup"> -->
         <!--  <img class="foto-contacte" src="@/assets/images/contacte-packetgrup.jpg" alt="Contacte Packet Grup"> -->
        </v-col>

        <v-col lg="6" sm="12" md="6" cols="12">

        </v-col>

        <v-col lg="12" sm="12" md="6" cols="12">
<!--           <div class="pregunta">
            <br>{{ $t('inici[0].frasecontacte') }}
          </div> -->
          <h2 class="mt-5 pt-5"> {{ $t('contacte[0].formularisubtitol')}} </h2>
          <tense-form-introduction :showform="showform" />
          <tense-content-form :showform="showform" />
        </v-col>
      </v-row>
      <v-row no-gutters>
         <v-col lg="6" sm="12" md="6" cols="12">
          <!-- <tense-form-introduction :showform="showform" /> -->
          <tense-form-response :showform="showform" />
        </v-col>
        
        
      </v-row>

    </v-container>

  </div>
</template>
<script>

import tenseFormAddress from '@/components/forms/tenseFormAddress.vue'
import tenseFormIntroduction from '@/components/forms/tenseFormIntroduction.vue'
import tenseFormResponse from '@/components/forms/tenseFormResponse.vue'
import tenseContentForm from '@/components/forms/tenseContentForm.vue'

export default {
  name: 'Contacto',
  metaInfo() {
    return { 
      metaInfo: {
        title: 'Contacte Packet Grup',
        titleTemplate: '%s | vue-meta Example App'
      },
      title: 'Contacte Packet Grup, formulari de contacte pressupost Packet Grup',
      description: 'Contacte Packet Grup, formulari de contacte pressupost Packet Grup',
    }
  },
  components: {
    tenseFormAddress,
    tenseFormIntroduction,
    tenseFormResponse,
    tenseContentForm,
  },
  props: {
    msg: String
  },
  data: () => ({
    loader: null,
    loading: false,
    result: "",
    buttonLoading: false,
/*     showform: true, */
    compoKey: 0,
  }),
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    },
  },
  computed: {
    showform () {
      return this.$store.state.showform
    }
  },
  methods: {
    hideForm: function() {
      this.showform = !this.showform
    },
    updatePanelist (ev) {
      this.currentPanelist = ev.target.value
    },
    handleresponse: function (){
      if(this.result != null)
      console.log('succes')
    }
  }
}

</script>

<style scoped lang="scss">
  h1 {
    color: black;
    border: 0;
    //@debugborder-bottom: 3px solid rgb(234, 95, 8);
  }

  h2 {
    font-size: 1.35em;
    border-bottom: 0px solid grey;
  }

  #contacto {
    left: 0%;
    top: 0;
  }

  .flexi {
    display: flex;
    position: absolute;
  }

  .lines-contact {
    position: absolute;
    left: 50%; 
    bottom: 110px;
    transform: rotateX(5deg);
  }

  .inside-enter-active, .inside-leave-active {
    transition: opacity 3.2s;
  }

  .inside-enter, .inside-leave-to {
    opacity: 0;
    transition: opacity .8s;
  }


  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
</style>
